import apiClientService from "./ApiClientService";

// Textele trimise automat (mementouri în chat, notificări, emailuri) — doar admin.
// Răspuns list: { templates: [{ key, channel, group, title, description, body,
//   defaultBody, placeholders: [{ name, label, example }], maxLength,
//   multiline, kind?, isCustom, updatedAt }] }

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   throw new Error(msg);
}

export async function getMessageTemplates() {
   return readOrThrow(
      await apiClientService.get("/message-templates"),
      "Nu am putut încărca textele.",
   );
}

export async function updateMessageTemplate(key, body) {
   return readOrThrow(
      await apiClientService.put(`/message-templates/${encodeURIComponent(key)}`, { body }),
      "Nu am putut salva textul.",
   );
}

export async function resetMessageTemplate(key) {
   return readOrThrow(
      await apiClientService.delete(`/message-templates/${encodeURIComponent(key)}`),
      "Nu am putut reveni la textul implicit.",
   );
}
